import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const catalogModule = defineModule({
  name: "catalog",
  label: "Catalog",
  requires: ["core", "accounts", "medialib"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "catalog/categories",
        permission: "catalog.view_category",
        page: () => import("./admin/CategoriesPage"),
      },
      {
        path: "catalog/brands",
        permission: "catalog.view_brand",
        page: () => import("./admin/BrandsPage"),
      },
      {
        path: "catalog/attributes",
        permission: "catalog.view_attribute",
        page: () => import("./admin/attributes/AttributesPage"),
      },
      {
        path: "catalog/attribute-sets/:uid",
        permission: "catalog.view_attributeset",
        page: () => import("./admin/attributes/SetBuilderPage"),
      },
    ],
    nav: [
      {
        id: "categories",
        group: "catalog",
        label: "catalog:categories.nav",
        icon: "folder-tree",
        to: "/catalog/categories",
        permission: "catalog.view_category",
        order: 2,
      },
      {
        id: "attributes",
        group: "catalog",
        label: "catalog:attributes.nav",
        icon: "tag",
        to: "/catalog/attributes",
        permission: "catalog.view_attribute",
        order: 4,
      },
      {
        id: "brands",
        group: "catalog",
        label: "catalog:brands.nav",
        icon: "box",
        to: "/catalog/brands",
        permission: "catalog.view_brand",
        order: 3,
      },
    ],
  },
});
